import { useState } from "react";
import { Stage, Btn, KpiStrip, BlockHead, ExpandTable, Detalhe, Selo } from "../components/primitives";

const CRM_URL = "https://crm-medico-seven.vercel.app";

const CHECKLIST_PREP = [
  "Login funcionando",
  "Perfil do médico preenchido (Configurações → Perfil)",
  "Endereço da clínica real cadastrado (Configurações → Clínicas)",
  "7 workflows N8N ativos em n8n.rc2clicks.com.br",
  "WhatsApp conectado na Evolution API",
];

const DADOS_TESTE = [
  { paciente: "Carlos Eduardo Souza",  email: "rc2clicks@gmail.com",        whatsapp: "(11) 91728-9005" },
  { paciente: "Roberto Alves Neto",    email: "rafael.andrade@msxi.com",    whatsapp: "(11) 97662-7373" },
  { paciente: "Ana Clara Mendonça",    email: "contato@rc2clicks.com.br",   whatsapp: "(11) 91728-9005" },
  { paciente: "Fernanda Lima Rocha",   email: "rc2clicks@gmail.com",        whatsapp: "(11) 97662-7373" },
];

const DEMO_STEPS = [
  { num: "1", titulo: "Dashboard",               duracao: "2 min",  desc: "Visão do dia, cards operacionais" },
  { num: "2", titulo: "Autorizações",            duracao: "12 min", desc: "Módulo principal, fluxo completo" },
  { num: "3", titulo: "Confirmações",            duracao: "5 min",  desc: "WhatsApp com Maps ao vivo" },
  { num: "4", titulo: "Tarefas",                 duracao: "3 min",  desc: "Fila gerada automaticamente" },
  { num: "5", titulo: "Configurações / Listas",  duracao: "5 min",  desc: "Personalização sem desenvolvedor" },
  { num: "6", titulo: "Usuários",                duracao: "2 min",  desc: "Gestão de acesso e plano" },
  { num: "7", titulo: "Ajuda",                   duracao: "1 min",  desc: "Manual sempre disponível" },
];

const MODULOS = [
  {
    num: "1",
    titulo: "Dashboard",
    cor: "var(--cat-violet)",
    mostrar: "6 cards operacionais, clicar em um card com número > 0",
    falar: "A secretária abre isso de manhã e já sabe o que precisa ser feito.",
    automacoes: [],
  },
  {
    num: "2",
    titulo: "Pacientes",
    cor: "var(--info)",
    mostrar: 'Buscar "Carlos" → abrir perfil. Mostrar Timeline, Procedimentos, Tarefas. Cadastrar novo procedimento (tipo Infiltração, data hoje)',
    falar: "Assim que o procedimento é registrado, o sistema dispara sozinho.",
    automacoes: ["WhatsApp D+1", "E-mail D+1", "Tarefa criada"],
  },
  {
    num: "3",
    titulo: "Confirmações de Retorno",
    cor: "var(--success)",
    mostrar: 'Carlos Eduardo Souza aparece com retorno em breve. Marcar como "Confirmado"',
    falar: "No momento da confirmação, o paciente já recebe o endereço e o Maps no WhatsApp.",
    automacoes: ["WhatsApp com endereço + Google Maps link"],
  },
  {
    num: "4",
    titulo: "Autorizações",
    cor: "var(--warn)",
    mostrar: 'Nova autorização → selecionar Ana Clara → convênio auto-preenchido. Campos com Combobox (lista padronizada de convênios, hospitais). Adicionar hospital novo inline ("Hospital São Luiz"). Status: Em análise → D+21 task criada. Status: Agendado → WhatsApp briefing disparado',
    falar: "Os campos de convênio e hospital vêm de uma lista pré-cadastrada — garante padronização nos relatórios.",
    automacoes: ["Task D+6", "Task D+21", "WhatsApp briefing com resumo do procedimento"],
  },
  {
    num: "5",
    titulo: "Tarefas",
    cor: "var(--cat-purple)",
    mostrar: 'Mostrar fila com tasks criadas automaticamente. Filtrar por "Hoje". Concluir uma task',
    falar: "Todas as tarefas são criadas pelo sistema — a secretária só executa.",
    automacoes: [],
  },
  {
    num: "6",
    titulo: "Configurações → Listas",
    cor: "var(--danger)",
    mostrar: "Mostrar listas de convênios, hospitais, fornecedores. Adicionar novo item ao vivo. Aba Templates: editar mensagem de confirmação",
    falar: "A secretária pode editar qualquer mensagem aqui sem precisar de desenvolvedor.",
    automacoes: [],
  },
  {
    num: "7",
    titulo: "Usuários",
    cor: "var(--signature)",
    mostrar: 'Contador "X de 3 usuários". Convidar usuário → perfis Admin / Secretária / Concierge',
    falar: "Cada clínica tem até 3 usuários inclusos.",
    automacoes: [],
  },
];

const SQL_CONFIRMACAO = `-- Criar retorno de teste (aparece em /confirmacoes)
INSERT INTO procedures (patient_id, tipo, data_procedimento, observacoes)
VALUES ('389fc78e-0686-44ae-8622-d09918366beb', 'Infiltração',
        (CURRENT_DATE - INTERVAL '28 days')::date, '[TESTE]');

-- Limpar após o teste
DELETE FROM procedures WHERE observacoes = '[TESTE]';`;

const SQL_AUTORIZACAO = `-- Criar e disparar briefing de autorização
INSERT INTO autorizacoes (patient_id, data_entrada, situacao, status, convenio, hospital, tipo_local_procedimento)
VALUES ('d7e3e992-d201-4547-9a62-a1c935b2a231', CURRENT_DATE, 'entrada', 'em_analise', 'Unimed', 'Hospital São Luiz', 'Artroscopia de joelho')
RETURNING id;

-- Depois atualizar o ID retornado:
UPDATE autorizacoes SET status = 'agendado' WHERE id = '[ID_RETORNADO]';`;

const CHECKLIST_ENTREGA = [
  "Substituir endereço de teste pelo real (Configurações → Clínicas)",
  "Editar pacientes com dados reais da equipe",
  "Configurar Perfil: nome, especialidade, CRM",
  "Ajustar templates de mensagem com telefone real",
  "Configurar SMTP no Supabase (evitar limite de 3 emails/hora)",
  "Testar convite de usuário para a secretária",
  "Fazer procedimento de teste e confirmar WhatsApp D+1",
];

function CodeBlock({ titulo, code }) {
  const [copied, setCopied] = useState(false);
  function copy() {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    });
  }
  return (
    <details className="explain">
      <summary><span>{titulo}</span></summary>
      <div className="explain-body" style={{ display: "grid", gap: 8 }}>
        <pre style={{
          background: "var(--surface-2)", borderRadius: 12, margin: 0,
          padding: "14px 16px", fontFamily: "var(--font-data)",
          fontSize: 12, color: "var(--ink)", lineHeight: 1.7,
          border: "1px solid var(--line)", overflowX: "auto",
          whiteSpace: "pre-wrap", wordBreak: "break-word",
        }}>
          {code}
        </pre>
        <div><Btn sm variant={copied ? "success" : "secondary"} onClick={copy}>{copied ? "✓ Copiado" : "Copiar"}</Btn></div>
      </div>
    </details>
  );
}

/** Lista simples numerada (roteiro de conferência). */
function Lista({ titulo, itens }) {
  return (
    <div className="klist">
      <div className="klist-head"><span className="eyebrow">{titulo}</span><span className="minibar-n">{itens.length} itens</span></div>
      {itens.map((item, i) => (
        <div key={i} className="klist-row">
          <span className="minibar-n" style={{ width: 18 }}>{i + 1}</span>
          <span className="txt">{item}</span>
        </div>
      ))}
    </div>
  );
}

export function CrmMedicoView() {
  return (
    <div className="view" style={{ maxWidth: 1040 }}>

      {/* Palco */}
      <Stage
        path="crm-medico"
        title="CRM"
        hl="Médico"
        lead="Roteiro de apresentação e manual de uso."
        actions={<a className="btn btn-primary btn-sm" href={CRM_URL} target="_blank" rel="noreferrer">Abrir CRM →</a>}
      />

      {/* Modelo comercial em faixa */}
      <KpiStrip items={[
        { label: "Implantação", value: "R$ 800 – 1.500", sub: "pagamento único" },
        { label: "Assinatura", value: "R$ 250 – 400", sub: "por mês, recorrente", tone: "ok" },
        { label: "Usuários", value: "3", sub: "inclusos; adicional na proposta" },
      ]} />

      <BlockHead title="Antes da demo" sub="Confira tudo antes de qualquer apresentação." />
      <Lista titulo="Checklist de preparação" itens={CHECKLIST_PREP} />

      <BlockHead title="Sequência de demo" sub="30 minutos, um passo por linha." />
      <div className="klist">
        {DEMO_STEPS.map((step) => (
          <div key={step.num} className="klist-row">
            <span className="minibar-n" style={{ width: 18 }}>{step.num}</span>
            <span className="txt"><strong style={{ fontWeight: 600 }}>{step.titulo}</strong><span style={{ color: "var(--muted)" }}> · {step.desc}</span></span>
            <span className="aside">{step.duracao}</span>
          </div>
        ))}
      </div>

      <BlockHead title="Módulos" sub="Clique para ver o que mostrar e o que falar." />
      <ExpandTable
        rows={MODULOS}
        rowKey={(m) => m.num}
        minWidth={480}
        columns={[
          { key: "num", label: "#", render: (m) => <span className="eyebrow" style={{ color: m.cor }}>{m.num}</span> },
          { key: "titulo", label: "Módulo", render: (m) => <span className="name">{m.titulo}</span> },
          { key: "auto", label: "Automações", align: "right", render: (m) => <span className="sub">{m.automacoes.length || "—"}</span> },
        ]}
        detail={(m) => (
          <div className="detail-grid">
            <Detalhe label="O que mostrar">{m.mostrar}</Detalhe>
            <Detalhe label="O que falar"><em>"{m.falar}"</em></Detalhe>
            {m.automacoes.length > 0 && (
              <div className="detalhe">
                <span className="eyebrow">Automações disparadas</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {m.automacoes.map((a, i) => <Selo key={i} tone="ok" dot={false}>✓ {a}</Selo>)}
                </div>
              </div>
            )}
          </div>
        )}
      />

      <BlockHead title="Dados de teste" />
      <div className="table-card">
        <div className="table-scroll">
          <table className="table" style={{ minWidth: 520 }}>
            <thead><tr><th>Paciente</th><th>E-mail</th><th>WhatsApp</th></tr></thead>
            <tbody>
              {DADOS_TESTE.map((d, i) => (
                <tr key={i}>
                  <td className="name">{d.paciente}</td>
                  <td style={{ fontFamily: "var(--font-data)", fontSize: 12.5 }}>{d.email}</td>
                  <td>{d.whatsapp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <BlockHead title="Scripts SQL para testes" sub="Abra para ver e copiar." />
      <div style={{ display: "grid", gap: 8 }}>
        <CodeBlock titulo="Script 1: teste de confirmação de retorno" code={SQL_CONFIRMACAO} />
        <CodeBlock titulo="Script 2: teste de briefing de autorização" code={SQL_AUTORIZACAO} />
      </div>

      <BlockHead title="Entrega ao cliente real" />
      <Lista titulo="Checklist de entrega" itens={CHECKLIST_ENTREGA} />
    </div>
  );
}
